import { Row } from "antd";
import React, { useState } from "react";
import RightDrawer from "./drawer";
import { MenuOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import { IUsers } from "../interfaces";

const AppHeader = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const user: IUsers = JSON.parse(localStorage.getItem("LOGGED_IN_USER"));

  const isMobile = useMediaQuery({
    query: "(max-width: 769px)",
  });

  return (
    isMobile && (
      <>
        <Row
          style={{
            height: "10vh",
            background: "white",
            width: "100%",
            padding: "1.2em",
            position: "sticky",
          }}
          align={"middle"}
          justify={"space-between"}
        >
          <h1 style={{ margin: "0%" }}>
            {user?.first_name} {user?.last_name}
          </h1>{" "}
          <MenuOutlined
            style={{ fontSize: "1.5em", cursor: "pointer" }}
            onClick={() => setIsDrawerOpen(true)}
          />
        </Row>

        <RightDrawer
          isDrawerOpen={isDrawerOpen}
          setIsDrawerOpen={setIsDrawerOpen}
        />
      </>
    )
  );
};

export default AppHeader;
